import { useMemo } from 'react';
import { useSegment } from '@repo/poly-hooks/segment';
import { useCurrentDevice } from '@repo/shared-kit/hooks/use-current-device';
import { useMaybeKycContext } from '../context/kyc-context';
import { kycEvents } from './events';

interface UseKycTrackingParams {
  trackingPrefix?: string;
  membershipId?: string;
  userId?: string;
  trackingEventOrigin?: string | null;
  provider?: string;
}

export function useKycTracking(overrides?: UseKycTrackingParams) {
  const context = useMaybeKycContext();
  const { isMobileBrowser } = useCurrentDevice();
  const segment = useSegment();

  const prefix = overrides?.trackingPrefix ?? context?.trackingPrefix ?? '';
  const membershipId = overrides?.membershipId ?? context?.membershipId;
  const userId = overrides?.userId ?? context?.userId;
  const origin = overrides?.trackingEventOrigin ?? context?.trackingEventOrigin ?? undefined;
  const provider = overrides?.provider;

  return useMemo(
    () =>
      kycEvents(
        prefix,
        {
          membershipId,
          userId,
          isMobileBrowser,
          origin,
          provider,
          domain: window.location.hostname,
        },
        segment
      ),
    [prefix, membershipId, userId, isMobileBrowser, origin, provider, segment]
  );
}
